/* eslint-disable */
import React, { useContext, useState, useEffect } from 'react';
import { NavLink, useLocation, Link } from 'react-router-dom';
import { PageContext } from '../../../context/PageContextProvider';
import Logo from '../../../assets/images/logo.svg';
import whiteLogo from '../../../assets/images/whiteLogo.svg';
import ServicesAPI from '../../../api/services';
import styles from './index.module.scss';

const MobileBottomBar = () => {
  const { language, theme } = useContext(PageContext);
  const location = useLocation();
  const [contactOpen, setContactOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeAccordion, setActiveAccordion] = useState(null); // 'services' | 'useful' | null
  const [services, setServices] = useState([]);

  // Default services fallback in case API is delayed
  const defaultServices = [
    { AZ: 'Mühasibatlıq və Maliyyə Uçotu', ENG: 'Accounting & Financial Accounting', RU: 'Бухгалтерский и финансовый учет', TR: 'Muhasebe ve Finansal Muhasebe' },
    { AZ: 'Vergi Uçotu və Audit Xidmətləri', ENG: 'Tax Accounting & Audit Services', RU: 'Налоговый учет и аудиторские услуги', TR: 'Vergi Muhasebesi ve Denetim Hizmetleri' },
    { AZ: 'Hüquqi Xidmətlər və Məsləhət', ENG: 'Legal Services & Consulting', RU: 'Юридические услуги и консультации', TR: 'Hukuki Hizmetler ve Danışmanlık' },
    { AZ: 'Kadr və Əmək Qanunvericiliyi', ENG: 'HR & Labor Legislation', RU: 'Кадровое и трудовое законодательство', TR: 'İK ve İş Mevzuatı' },
    { AZ: '1C və ERP Sistemlərinin Qurulması', ENG: '1C & ERP Systems Implementation', RU: 'Внедрение систем 1С и ERP', TR: '1C ve ERP Sistemlerinin Kurulumu' },
    { AZ: 'Biznes və İqtisadi Məsləhət', ENG: 'Business & Economic Consulting', RU: 'Бизнес и экономический консалтинг', TR: 'İş ve Ekonomik Danışmanlık' },
  ];

  useEffect(() => {
    (async () => {
      try {
        const res = await ServicesAPI.getCategories();
        if (res?.data && res.data.length > 0) {
          setServices(res.data);
        } else {
          setServices(defaultServices);
        }
      } catch (e) {
        setServices(defaultServices);
      }
    })();
  }, []);

  // Prevent body scrolling when a bottom sheet is open
  useEffect(() => {
    if (menuOpen || contactOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen, contactOpen]);

  // Close sheets when route changes
  useEffect(() => {
    setMenuOpen(false);
    setContactOpen(false);
    setActiveAccordion(null);
  }, [location.pathname]);

  const toggleAccordion = (key) => {
    setActiveAccordion((prev) => (prev === key ? null : key));
  };

  const labels = {
    home: { AZ: 'Əsas', ENG: 'Home', RU: 'Главная', TR: 'Ana Sayfa' },
    services: { AZ: 'Xidmətlər', ENG: 'Services', RU: 'Услуги', TR: 'Hizmetler' },
    servicesDesc: {
      AZ: 'Hüquq, vergi, audit və konsaltinq istiqamətləri',
      ENG: 'Legal, tax, audit and consulting directions',
      RU: 'Юридические, налоговые, аудиторские направления',
      TR: 'Hukuk, vergi, denetim ve danışmanlık alanları'
    },
    allServices: { AZ: 'Bütün Xidmətlər Kataloqu', ENG: 'All Services Catalog', RU: 'Весь каталог услуг', TR: 'Tüm Hizmetler Kataloğu' },
    useful: { AZ: 'Faydalı', ENG: 'Useful', RU: 'Полезное', TR: 'Faydalı' },
    usefulDesc: {
      AZ: 'Xəbərlər, tədbirlər, təqvimlər və kalkulyatorlar',
      ENG: 'News, events, calendar and calculators',
      RU: 'Новости, события, календарь и калькуляторы',
      TR: 'Haberler, etkinlikler, takvim ve hesaplayıcılar'
    },
    calculator: { AZ: 'Kalkulyator', ENG: 'Calculator', RU: 'Калькулятор', TR: 'Hesaplayıcı' },
    contact: { AZ: 'Əlaqə', ENG: 'Contact', RU: 'Контакты', TR: 'İletişim' },
    menu: { AZ: 'Menyu', ENG: 'Menu', RU: 'Меню', TR: 'Menü' },
    quickContact: { AZ: 'Sürətli Əlaqə', ENG: 'Quick Contact', RU: 'Быстрая связь', TR: 'Hızlı İletişim' },
    callUs: { AZ: 'Zəng edin: +994 (55) 424 81 26', ENG: 'Call: +994 (55) 424 81 26', RU: 'Позвонить: +994 (55) 424 81 26', TR: 'Ara: +994 (55) 424 81 26' },
    whatsapp: { AZ: 'WhatsApp ilə yazın', ENG: 'Chat on WhatsApp', RU: 'Написать в WhatsApp', TR: 'WhatsApp ile yazın' },
    emailUs: { AZ: 'E-poçt: qmirismayil@gmail.com', ENG: 'Email: qmirismayil@gmail.com', RU: 'Почта: qmirismayil@gmail.com', TR: 'E-posta: qmirismayil@gmail.com' },
    contactPage: { AZ: 'Bütün Əlaqə Məlumatları', ENG: 'All Contact Details', RU: 'Все контакты', TR: 'Tüm İletişim Bilgileri' },
    about: { AZ: 'Haqqımızda', ENG: 'About us', RU: 'О нас', TR: 'Hakkımızda' },
    aboutDesc: { AZ: 'Şirkətin missiyası, dəyərlər və komandamız', ENG: 'Mission, values and our team', RU: 'Миссия, ценности и команда', TR: 'Misyon, değerler ve ekibimiz' },
    careers: { AZ: 'Karyera', ENG: 'Careers', RU: 'Карьера', TR: 'Kariyer' },
    careersDesc: { AZ: 'Açıq vakansiyalar və müraciət', ENG: 'Open vacancies and application', RU: 'Открытые вакансии и отклик', TR: 'Açık pozisyonlar ve başvuru' },
    termsHeading: { AZ: 'Qaydalar və Şərtlər', ENG: 'Terms and Policies', RU: 'Условия и положения', TR: 'Kullanım ve Şartlar' },
    termsUse: { AZ: 'İstifadə qaydaları', ENG: 'Terms of Use', RU: 'Условия использования', TR: 'Kullanım Koşulları' },
    privacy: { AZ: 'Məxfilik siyasəti', ENG: 'Privacy Policy', RU: 'Политика конфиденциальности', TR: 'Gizlilik Politikası' },
    cookie: { AZ: 'Kuki siyasəti', ENG: 'Cookie Policy', RU: 'Политика cookie', TR: 'Çerez Politikası' },
    close: { AZ: 'Bağla', ENG: 'Close', RU: 'Закрыть', TR: 'Kapat' }
  };

  const getLabel = (key) => labels[key]?.[language] || labels[key]?.AZ || key;

  // Faydalı sub-links
  const usefulSubLinks = [
    {
      path: '/useful/news',
      icon: '📰',
      AZ: 'Xəbərlər və Məqalələr',
      ENG: 'News & Articles',
      RU: 'Новости и статьи',
      TR: 'Haberler ve Makaleler',
    },
    {
      path: '/useful/event',
      icon: '🎟️',
      AZ: 'Tədbirlər',
      ENG: 'Events',
      RU: 'События',
      TR: 'Etkinlikler',
    },
    {
      path: '/useful/training',
      icon: '🎓',
      AZ: 'Təlim və Seminarlar',
      ENG: 'Trainings & Seminars',
      RU: 'Тренинги и семинары',
      TR: 'Eğitim ve Seminerler',
    },
    {
      path: '/useful/calendar',
      icon: '📅',
      AZ: 'İstehsalat Təqvimi',
      ENG: 'Production Calendar',
      RU: 'Производственный календарь',
      TR: 'Üretim Takvimi',
    },
    {
      path: '/useful/currency',
      icon: '💱',
      AZ: 'Valyuta Məzənnələri',
      ENG: 'Currency Rates',
      RU: 'Курсы валют',
      TR: 'Döviz Kurları',
    },
    {
      path: '/useful/calculator',
      icon: '🧮',
      AZ: 'Kalkulyatorlar',
      ENG: 'Calculators',
      RU: 'Калькуляторы',
      TR: 'Hesaplayıcılar',
    },
  ];

  return (
    <>
      {/* 1. Full Mobile Menu Drawer / Fullscreen Sheet */}
      {menuOpen && (
        <div className={styles.menu_overlay} onClick={() => setMenuOpen(false)}>
          <div className={styles.menu_sheet} onClick={(e) => e.stopPropagation()}>
            {/* Sheet Header - Fixed at Top */}
            <div className={styles.menu_sheet_header}>
              <Link to="/" onClick={() => setMenuOpen(false)} className={styles.menu_logo}>
                <img src={theme === 'dark' ? whiteLogo : Logo} alt="BPG Consulting" />
              </Link>
              <div className={styles.header_right_wrap}>
                <span className={styles.menu_badge}>{getLabel('menu')}</span>
                <button
                  type="button"
                  className={styles.close_btn}
                  onClick={() => setMenuOpen(false)}
                  aria-label={getLabel('close')}
                >
                  ✕
                </button>
              </div>
            </div>

            {/* Scrollable Content */}
            <div className={styles.menu_scroll_content}>
              {/* ORDER 1: XİDMƏTLƏR (ACCORDION) */}
              <div className={`${styles.accordion_item} ${activeAccordion === 'services' ? styles.accordion_open : ''}`}>
                <button
                  type="button"
                  className={styles.accordion_header_btn}
                  onClick={() => toggleAccordion('services')}
                  aria-expanded={activeAccordion === 'services'}
                >
                  <div className={styles.accordion_btn_left}>
                    <div className={`${styles.accordion_icon_box} ${styles.icon_services}`}>
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
                      </svg>
                    </div>
                    <div className={styles.accordion_title_box}>
                      <strong>{getLabel('services')}</strong>
                      <span>{getLabel('servicesDesc')}</span>
                    </div>
                  </div>
                  <div className={styles.accordion_btn_right}>
                    <span className={styles.accordion_count_badge}>{services.length}</span>
                    <span className={`${styles.accordion_arrow} ${activeAccordion === 'services' ? styles.arrow_up : ''}`}>
                      ▼
                    </span>
                  </div>
                </button>

                {/* Subcategories list for Services */}
                <div className={`${styles.accordion_collapse} ${activeAccordion === 'services' ? styles.collapse_show : ''}`}>
                  <div className={styles.sublist_inner}>
                    {services.map((item, idx) => {
                      const srvTitle = item[language] || item.AZ || item.service_az || item.service_eng || `Xidmət ${idx + 1}`;
                      const targetPath = `/services/${idx + 1}`;
                      const isSrvActive = location.pathname === targetPath;
                      return (
                        <Link
                          key={`srv-sub-${idx}`}
                          to={targetPath}
                          onClick={() => setMenuOpen(false)}
                          className={`${styles.sublist_row} ${isSrvActive ? styles.sublist_active : ''}`}
                        >
                          <div className={styles.sublist_bullet} />
                          <span className={styles.sublist_title}>{srvTitle}</span>
                          <span className={styles.sublist_chevron}>›</span>
                        </Link>
                      );
                    })}
                    <Link
                      to="/services/1"
                      onClick={() => setMenuOpen(false)}
                      className={styles.sublist_all_link}
                    >
                      <span>📂</span>
                      <strong>{getLabel('allServices')}</strong>
                      <span>→</span>
                    </Link>
                  </div>
                </div>
              </div>

              {/* ORDER 2: FAYDALI (ACCORDION) */}
              <div className={`${styles.accordion_item} ${activeAccordion === 'useful' ? styles.accordion_open : ''}`}>
                <button
                  type="button"
                  className={styles.accordion_header_btn}
                  onClick={() => toggleAccordion('useful')}
                  aria-expanded={activeAccordion === 'useful'}
                >
                  <div className={styles.accordion_btn_left}>
                    <div className={`${styles.accordion_icon_box} ${styles.icon_useful}`}>
                      <span style={{ fontSize: '20px' }}>💡</span>
                    </div>
                    <div className={styles.accordion_title_box}>
                      <strong>{getLabel('useful')}</strong>
                      <span>{getLabel('usefulDesc')}</span>
                    </div>
                  </div>
                  <div className={styles.accordion_btn_right}>
                    <span className={styles.accordion_count_badge}>{usefulSubLinks.length}</span>
                    <span className={`${styles.accordion_arrow} ${activeAccordion === 'useful' ? styles.arrow_up : ''}`}>
                      ▼
                    </span>
                  </div>
                </button>

                {/* Subcategories list for Faydalı */}
                <div className={`${styles.accordion_collapse} ${activeAccordion === 'useful' ? styles.collapse_show : ''}`}>
                  <div className={styles.sublist_inner}>
                    {usefulSubLinks.map((item, idx) => {
                      const linkTitle = item[language] || item.AZ;
                      const isLinkActive = location.pathname === item.path;
                      return (
                        <Link
                          key={`useful-sub-${idx}`}
                          to={item.path}
                          onClick={() => setMenuOpen(false)}
                          className={`${styles.sublist_row} ${isLinkActive ? styles.sublist_active : ''}`}
                        >
                          <span className={styles.sublist_icon}>{item.icon}</span>
                          <span className={styles.sublist_title}>{linkTitle}</span>
                          <span className={styles.sublist_chevron}>›</span>
                        </Link>
                      );
                    })}
                  </div>
                </div>
              </div>

              {/* ORDER 3: HAQQIMIZDA (DIRECT CARD) */}
              <Link
                to="/about"
                onClick={() => setMenuOpen(false)}
                className={`${styles.direct_nav_card} ${location.pathname === '/about' ? styles.card_active : ''}`}
              >
                <div className={styles.direct_card_icon_wrap}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 21h18M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16M9 9h6M9 13h6M9 17h6" />
                  </svg>
                </div>
                <div className={styles.direct_card_text}>
                  <strong>{getLabel('about')}</strong>
                  <span>{getLabel('aboutDesc')}</span>
                </div>
                <span className={styles.direct_card_arrow}>→</span>
              </Link>

              {/* ORDER 4: KARYERA (DIRECT CARD) */}
              <Link
                to="/careers"
                onClick={() => setMenuOpen(false)}
                className={`${styles.direct_nav_card} ${location.pathname.startsWith('/careers') || location.pathname.includes('/vacancy') ? styles.card_active : ''}`}
              >
                <div className={`${styles.direct_card_icon_wrap} ${styles.icon_careers}`}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                    <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
                    <line x1="2" y1="12" x2="22" y2="12" />
                  </svg>
                </div>
                <div className={styles.direct_card_text}>
                  <strong>{getLabel('careers')}</strong>
                  <span>{getLabel('careersDesc')}</span>
                </div>
                <span className={styles.direct_card_arrow}>→</span>
              </Link>

              {/* ORDER 5: DIGƏRLƏRİ / SÜRƏTLİ ƏLAQƏ */}
              <div className={styles.menu_section}>
                <div className={styles.section_title_wrap}>
                  <span className={styles.section_badge}>📞</span>
                  <h4 className={styles.section_title}>{getLabel('quickContact')}</h4>
                </div>
                <div className={styles.contact_quick_grid}>
                  <a href="tel:+994554248126" className={styles.quick_c_btn_call}>
                    <span>📞</span>
                    <strong>+994 55 424 81 26</strong>
                  </a>
                  <a href="https://wa.me/994554248126" target="_blank" rel="noreferrer" className={styles.quick_c_btn_wa}>
                    <span>💬</span>
                    <strong>WhatsApp</strong>
                  </a>
                </div>
              </div>

              {/* ORDER 6: QAYDALAR VƏ ŞƏRTLƏR */}
              <div className={styles.terms_footer}>
                <div className={styles.terms_links}>
                  <Link to="/term-conditions" onClick={() => setMenuOpen(false)}>{getLabel('termsUse')}</Link>
                  <span>•</span>
                  <Link to="/privacy" onClick={() => setMenuOpen(false)}>{getLabel('privacy')}</Link>
                  <span>•</span>
                  <Link to="/cookie-policy" onClick={() => setMenuOpen(false)}>{getLabel('cookie')}</Link>
                </div>
                <div className={styles.copy_text}>
                  © 2026 BPG Consulting Centre. Bütün hüquqlar qorunur.
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 2. Quick Contact Modal / Bottom Sheet */}
      {contactOpen && (
        <div className={styles.contact_overlay} onClick={() => setContactOpen(false)}>
          <div className={styles.contact_sheet} onClick={(e) => e.stopPropagation()}>
            <div className={styles.sheet_handle} />
            <div className={styles.sheet_header}>
              <h3>{getLabel('quickContact')}</h3>
              <button type="button" onClick={() => setContactOpen(false)} aria-label={getLabel('close')}>
                ✕
              </button>
            </div>
            
            <div className={styles.sheet_actions}>
              <a href="tel:+994554248126" className={styles.action_btn_call}>
                <span className={styles.action_icon}>📞</span>
                <div>
                  <strong>{getLabel('callUs')}</strong>
                  <span>Həftəiçi 09:00 - 18:00</span>
                </div>
              </a>

              <a href="https://wa.me/994554248126" target="_blank" rel="noreferrer" className={styles.action_btn_wa}>
                <span className={styles.action_icon}>💬</span>
                <div>
                  <strong>{getLabel('whatsapp')}</strong>
                  <span>Operativ cavab</span>
                </div>
              </a>

              <a href="mailto:qmirismayil@gmail.com" className={styles.action_btn_email}>
                <span className={styles.action_icon}>✉️</span>
                <div>
                  <strong>{getLabel('emailUs')}</strong>
                  <span>Rəsmi müraciətlər üçün</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      )}

      {/* 3. Primary Mobile Bottom Dock (Fixed at screen bottom) */}
      <aside className={styles.mobile_dock} aria-label="Mobil Sürətli Naviqasiya">
        <nav className={styles.dock_container}>
          {/* 1. Home */}
          <NavLink
            to="/"
            className={({ isActive }) =>
              `${styles.dock_item} ${isActive && location.pathname === '/' ? styles.active : ''}`
            }
          >
            <div className={styles.icon_wrap}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
              </svg>
            </div>
            <span className={styles.dock_label}>{getLabel('home')}</span>
          </NavLink>

          {/* 2. Services */}
          <NavLink
            to="/services/1"
            className={({ isActive }) =>
              `${styles.dock_item} ${location.pathname.startsWith('/services') ? styles.active : ''}`
            }
          >
            <div className={styles.icon_wrap}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
              </svg>
            </div>
            <span className={styles.dock_label}>{getLabel('services')}</span>
          </NavLink>

          {/* 3. Calculator */}
          <NavLink
            to="/useful/calculator"
            className={({ isActive }) =>
              `${styles.dock_item} ${location.pathname.includes('/calculator') ? styles.active : ''}`
            }
          >
            <div className={styles.icon_wrap}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="4" y="2" width="16" height="20" rx="2" />
                <line x1="8" y1="6" x2="16" y2="6" />
                <line x1="16" y1="14" x2="16" y2="18" />
                <path d="M16 10h.01" />
                <path d="M12 10h.01" />
                <path d="M8 10h.01" />
                <path d="M12 14h.01" />
                <path d="M8 14h.01" />
                <path d="M12 18h.01" />
                <path d="M8 18h.01" />
              </svg>
            </div>
            <span className={styles.dock_label}>{getLabel('calculator')}</span>
          </NavLink>

          {/* 4. Contact (Opens Quick Contact Sheet) */}
          <button
            type="button"
            onClick={() => {
              setMenuOpen(false);
              setContactOpen(!contactOpen);
            }}
            className={`${styles.dock_item_btn} ${location.pathname === '/contact' || contactOpen ? styles.active : ''}`}
            aria-label={getLabel('contact')}
          >
            <div className={styles.icon_wrap}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
            </div>
            <span className={styles.dock_label}>{getLabel('contact')}</span>
          </button>

          {/* 5. Menyu (☰ Hamburger - Opens Full Navigation Sheet) */}
          <button
            type="button"
            onClick={() => {
              setContactOpen(false);
              setMenuOpen(!menuOpen);
            }}
            className={`${styles.dock_item_btn} ${menuOpen ? styles.active : ''}`}
            aria-label={getLabel('menu')}
          >
            <div className={styles.icon_wrap}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            </div>
            <span className={styles.dock_label}>{getLabel('menu')}</span>
          </button>
        </nav>
      </aside>
    </>
  );
};

export default MobileBottomBar;
